import React, { useState, FunctionComponent, useRef, ChangeEvent } from 'react';
import { Presentation } from './presentation';

type Props = {
  personId: number;
  instagramIcon: string;
  xIcon: string;
  noIconPersonImg: string;
  icon: string;
  name: string;
  instagram: string;
  twitter: string;
  follows: number | null;
  fromPage: string;
  isShow: boolean;
  positions: string;
  resume: "" | File | { name: { url: string; } };
  jobResume: "" | File | { name: { url: string; } };
  handleUploadIcon: (file: File) => void;
  handleOpenMemoModal?: () => void;
  isOneYearPassed: boolean;
};

export const Component: FunctionComponent<Props> = ({
  personId,
  instagramIcon,
  xIcon,
  noIconPersonImg,
  icon,
  name,
  instagram,
  twitter,
  follows,
  fromPage,
  isShow,
  positions,
  resume,
  jobResume,
  handleUploadIcon,
  handleOpenMemoModal,
  isOneYearPassed,
}) => {
  const [file, setFile] = useState<File | ''>('');
  const fileInputRef = useRef<HTMLInputElement>(null);

  const onFileInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    // ファイル未選択またはサイズ超過時は処理を中断
    if (!file || file.size > 5242880) {
      // サイズ超過の場合のみアラート表示
      if (file && file.size > 5242880) {
        alert('サイズが大きすぎます。推奨容量（1MB）以下にして下さい。');
      }
      return;
    }
    setFile(file);
    handleUploadIcon(file);
  }

  return (
    <Presentation
      personId={personId}
      instagramIcon={instagramIcon}
      xIcon={xIcon}
      noIconPersonImg={noIconPersonImg}
      icon={icon}
      name={name}
      instagram={instagram}
      twitter={twitter}
      follows={follows}
      fromPage={fromPage}
      isShow={isShow}
      positions={positions}
      handleUploadIcon={handleUploadIcon}
      file={file}
      onFileInputChange={onFileInputChange}
      fileInputRef={fileInputRef}
      resume={resume}
      jobResume={jobResume}
      handleOpenMemoModal={handleOpenMemoModal}
      isOneYearPassed={isOneYearPassed}
    />
  );
};
